/**
 * 版本更新提示组件
 *
 * 静默条幅样式，显示在页面顶部
 * 用户可以选择刷新或稍后
 */

import React from 'react';
import { Button } from 'antd';
import { ReloadOutlined, CloseOutlined } from '@ant-design/icons';
import styles from './UpdateNotification.module.css';

export interface UpdateNotificationProps {
  /** 是否显示 */
  visible: boolean;
  /** 新版本号 */
  newVersion: string | null;
  /** 刷新回调 */
  onRefresh: () => void;
  /** 关闭回调 */
  onDismiss: () => void;
}

export const UpdateNotification: React.FC<UpdateNotificationProps> = ({
  visible,
  newVersion,
  onRefresh,
  onDismiss,
}) => {
  if (!visible) return null;

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <span className={styles.icon}>🆕</span>
        <span className={styles.message}>
          新版本可用 {newVersion && <span className={styles.version}>(v{newVersion})</span>}
        </span>
        <Button
          type="primary"
          size="small"
          icon={<ReloadOutlined />}
          onClick={onRefresh}
          className={styles.refreshButton}
        >
          刷新获取更新
        </Button>
        <Button
          type="text"
          size="small"
          icon={<CloseOutlined />}
          onClick={onDismiss}
          className={styles.dismissButton}
        />
      </div>
    </div>
  );
};

export default UpdateNotification;
